import React, { Component, Fragment } from 'react';
import { Form, Button, Icon, Modal, message, Tag } from 'antd';
import { connect } from 'react-redux';
import { SetupAction, CoinAction } from '../../actions';
import { bindActionCreators } from 'redux';
import { CofirmationWrapper, FormWrapper } from './style';
import AssetFormModal from '../../components/AssetFormModal';
import Coins from '../../components/Coins';
import CreateAsset from '../CreateAsset';
import { ASSET_TYPE_LIST } from '../../config/constants';
import { putExchange, updateAssetCoins, getCoins } from '../../common/fetch';
import RemoveConfirmation from './Confirmation';
import { DashLinksToolTip } from '../Hosting/Utils';

const { Item } = Form;

class Assets extends Component {
	state = {
		newAsset: false,
		isOpen: false,
		addType: 'preset',
		currency: 'btc',
		isNew: false,
		isConfigureEdit: false,
		editConfigureScreen: 'coin-pro',
		editAsset: {},
		selectedAssets: ['btc', 'usdt', 'eth', 'xht'],
		selectedCoinData: {},
		coinFormData: {},
		formData: {},
		coins: [],
		display_content: '0',
		button_top: '-40px',
		currentAssetScreen: 'step1',
		screenChange: false,
		removeCoin: {},
		isRemove: false,
	};

	componentDidMount() {
		this.updateCoins();
		this.setCoinData();
	}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps.coins) !== JSON.stringify(this.props.coins)) {
			this.setCoinData();
		}
		if (JSON.stringify(prevProps.state) !== JSON.stringify(this.props.state)) {
			this.updateCoins();
		}
		if (this.state.display_content === '0') {
			setTimeout(() => {
				this.setState({ button_top: "0px" });
			}, 1300);
			setTimeout(() => {
				this.setState({ display_content: "1" });
			}, 1500);
		}
	}

	updateAssetScreen = (screen) => {
		this.setState({ currentAssetScreen: screen, screenChange: false })
	}

	updateCoins = () => {
		if (this.props.state
			&& this.props.state.coins
			&& this.props.state.coins.length) {
			const allKeys = this.props.allCoins.map(data => data.symbol);
			const coinKeys = this.props.state.coins.map(data => (
				typeof data === 'string' ? data : data.symbol
			))
			const selectedAssets = coinKeys.filter(symbol => allKeys.includes(symbol));
			this.setState({
				selectedAssets
			});
		}
	};

	setCoinData = () => {
		if (this.props.coins.length) {
			let filterData = this.props.coins.filter(data => !this.state.selectedAssets.includes(data.symbol));
			if (filterData.length) {
				this.setState({
					selectedCoinData: filterData[0],
					coinFormData: filterData[0]
				});
			}
		}
	};

	openModal = (symbol, isNew = true) => {
		this.setState({ newAsset: true, currency: symbol, isNew });
	};

	closeModal = () => {
		this.setState({ newAsset: false });
	};

	onChange = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	};

	handleOkModal = () => {
		if (this.state.addType === 'preset') {
			this.setState({ isOpen: false });
		} else {
			this.setState({
				isOpen: false,
				newAsset: true,
				currency: 'new',
				isNew: true,
			});
		}
	};

	handleCancelModal = () => {
		if (this.state.currentAssetScreen === 'step2') {
			this.setState({ screenChange: true });
		} else {
			this.setState({ isOpen: false, isConfigureEdit: false, editAsset: {}, screenChange: false, isRemove: false });
		}

	};

	handleSelect = (v) => {
		this.setState({ currency: v });
	};

	onHandleRemoveAsset = (symbol) => {
		const { state, actions } = this.props;
		const selectedAssets = this.state.selectedAssets.filter(data => data !== symbol);
		const newData = { ...state, coins: selectedAssets };
		actions.updateBiz(newData);
		this.setState({
			selectedAssets,
			isRemove: false
		});
	};

	handleEdit = (data) => {
		this.setState({
			isConfigureEdit: true,
			editConfigureScreen: 'step3',
			editAsset: data
		});
	};

	handleSubmit = async (e) => {
		e.preventDefault();
		const { state } = this.props;
		if (this.state.selectedAssets.length < 2) {
			message.warn('You need to set at least two assets.');
			return;
		}
		try {
			const exchangeBody = {
				id: state.id,
				info: {
					// biz: {
					// 	ASSETS: state.ASSETS,
					// },
					is_temp: state.is_temp,
				},
				coins: this.state.selectedAssets
			};
			// delete exchangeBody.info.biz.id;
			await putExchange(exchangeBody);
			this.props.actions.updateBiz(exchangeBody);
			this.props.onOk();
		} catch (error) {
			console.error(error);
			message.error('Failed to update setup configs');
		}
	};

	renderAssets = () => {
		const { selectedAssets } = this.state;
		const iconStyle = {
			fontSize: '22px',
			color: '#3A4FFF',
			marginRight: '5px'
		};
		return this.props.coins.filter((coin) => selectedAssets.includes(coin.symbol))
			.map((item, index) => {
				return (
					<div className="coin-list" key={`symbol-${index}`}>
						<div className="coin">
							<Coins
								type={item.symbol}
								color={item.ASSET_COLOR}
								small={true}
							/>
							<span className='coin-item'>{item.fullname}</span>
						</div>
						<div
							className="icons"
						>
							{item.verified
								? null
								: <Fragment>
									<Icon
										type="setting"
										style={iconStyle}
										onClick={() => {
											this.handleEdit(item);
										}}
									/>
									<span
										className="rm-left"
										onClick={() => {
											this.handleEdit(item);
										}}
									>
										Configure
									</span>
								</Fragment>
							}
							<span className="divide">|</span>
							<Icon
								type="minus-circle"
								style={iconStyle}
								onClick={() => {
									this.setState({ isRemove: true, removeCoin: item })
								}}
							/>
							<span
								className="rm-left"
								onClick={() => {
									this.setState({ isRemove: true, removeCoin: item })
								}}
							>
								Remove
							</span>
							{
								!item.verified ?
									<div className='icons'>
										<span className='divide'>|</span>
										<Tag className="new-tag">New</Tag>
									</div> :
									null
							}
						</div>

					</div>
				);
			});
	};

	getCoins = async () => {
		try {
			const res = await getCoins();
			const coins = await res.data.data.map((item) => {
				// NOTE: Monero set disabled
				if (item.symbol === 'xmr') {
					return {
						key: 'Monero',
						value: 'xmr',
						disabled: true,
						...item
					};
				}
				const filter = ASSET_TYPE_LIST.filter((obj) => obj.value === item.symbol);
				if (filter.length === 0) {
					return {
						key: item.fullname,
						value: item.symbol,
						...item
					};
				} else {
					return { ...filter[0], ...item };
				}
			});

			return this.props.setCoin(coins);
		} catch (error) {
			throw error;
		}
	};

	handleConfirmation = async (data, isEdit = false) => {
		const { editAsset } = this.state;
		if (isEdit) {
			try {
				// if (!data.logo) {
				// 	data.logo = '';
				// }
				delete data.key;
				delete data.value;
				// if (!data.network) data.network = '';
				// if (!data.standard) data.standard = '';
				// if (!data.fullname) data.fullname = editAsset.fullname;
				// if (!data.symbol) data.symbol = editAsset.symbol;
				// if (!data.min) data.min = editAsset.min;
				// if (!data.max) data.max = editAsset.max;
				// if (!data.increment_unit) data.increment_unit = editAsset.increment_unit;
				if (!data.code) data.code = editAsset.code;
				await updateAssetCoins(data);
				await this.getCoins();
				this.setState({ formData: {}, coinFormData: {} })
			} catch (error) {
				if (error && error.data) {
					message.error(error.data.message)
				}
			}
		} else {
			if (data.symbol) {
				let paramsData = {
					allow_deposit: data.allow_deposit,
					allow_withdrawal: data.allow_withdrawal,
					estimated_price: data.estimated_price,
					increment_unit: data.increment_unit,
					max: data.max,
					min: data.min,
					withdrawal_fee: data.withdrawal_fee,
					code: !data.code ? data.symbol.toLowerCase() : data.code
				}
				let selectedAssets = [...this.state.selectedAssets];
				if (!data.id) {
					try {
						await updateAssetCoins(paramsData);
						await this.getCoins();
					} catch (error) {
						if (error && error.data) {
							message.error(error.data.message)
						}
					}
				}
				if (!selectedAssets.includes(data.symbol)) {
					selectedAssets = [...selectedAssets, data.symbol];
				}
				const dataValues = {
					...this.props.state,
					coins: selectedAssets
				}
				this.props.actions.updateBiz(dataValues);
				this.setState({ selectedAssets, selectedCoinData: data });
			}
		}
	};
	updateFormData = (name, value) => {
		const coinFormData = { ...this.state.coinFormData };
		const formData = { ...this.state.formData };
		if (name === 'color') {
			coinFormData.meta = { color: value };
			formData.meta = { color: value };
		} else if (name === 'decimal_points') {
			coinFormData.meta = { ...coinFormData.meta, decimal_points: value };
			formData.meta = { ...formData.meta, decimal_points: value };
		} else {
			coinFormData[name] = value;
			formData[name] = value;
		}
		this.setState({ coinFormData, formData });
	};

	render() {
		const {
			newAsset,
			currency,
			isOpen,
			isNew,
			selectedAssets,
			isConfigureEdit,
			formData,
			button_top,
			isRemove,
			removeCoin
		} = this.state;
		// const radioStyle = {
		// 	display: 'flex',
		// 	paddingTop: '12px',
		// };
		return (
			<FormWrapper style={{ paddingTop: '24px' }}>
				<Form onSubmit={this.handleSubmit} className="asset-form">
					<Item className="last">
						<h3 className="form-label">Default Assets</h3>
						<p>
							Below are preconfigured coins. Click configure to change
							deposit and withdrawal limits
						</p>
						<div className="coin-spacing">
							{this.renderAssets()}
						</div>
						<div className="new-asset d-flex">
							{/* <h3 className="form-label">Add Asset</h3> */}
							<p
								className="add-asset"
								onClick={() => this.setState({ isOpen: true })}
							>
								<Icon type="plus-circle" style={{ fontSize: '33px' }} />
									<span>Add Asset</span>
							</p>
							<div className='steps-dash-link'>
								<DashLinksToolTip renderLink={'https://www.youtube.com/watch?v=AVAqJMR6ViE&t=76s'}/>
							</div>
						</div>
					</Item>
					<div className='smooth-drop'>
						<div className='animation-bounce'>
							<div className='align-center'>
								<div className='details-container' style={{ opacity: this.state.display_content }}>
									<div className='info-icon'>i</div>
									<div>Note: <span>All details can be changed at a later date</span></div>
								</div>
							</div>
							<Button
								block
								type="primary"
								htmlType="submit"
								style={{ top: button_top }}
								disabled={selectedAssets.length < 2}
							>
								Next
							</Button>
						</div>
					</div>

				</Form>
				{newAsset ? (
					<AssetFormModal
						title="Add an Asset"
						visible={newAsset}
						tiers={this.props.state.ACCOUNT_TIERS}
						currency={currency}
						isNew={isNew}
						onOk={this.closeModal}
						onCancel={this.closeModal}
					/>
				) : null}
				<Modal
					visible={isOpen || isConfigureEdit || isRemove}
					footer={null}
					onOk={this.handleOkModal}
					onCancel={this.handleCancelModal}
				>
					{isOpen || isConfigureEdit
						? <CreateAsset
							isExchangeWizard={true}
							editAsset={this.state.editAsset}
							isConfigureEdit={this.state.isConfigureEdit}
							editConfigureScreen={this.state.editConfigureScreen}
							coins={this.props.coins}
							exchangeCoins={
								this.props.coins.filter((coin) =>
									selectedAssets.includes(coin.symbol))
							}
							formData={formData}
							handleConfirmation={this.handleConfirmation}
							onClose={this.handleCancelModal}
							updateFormData={this.updateFormData}
							getCoins={this.getCoins}
							updateAssetScreen={this.updateAssetScreen}
							screenChange={this.state.screenChange}
						/>
						:
						<CofirmationWrapper>
							<RemoveConfirmation
								onCancel={this.handleCancelModal}
								onHandleRemoveAsset={this.onHandleRemoveAsset}
								removeCoin={removeCoin}
								removeContent={'Assets'}
							/>
						</CofirmationWrapper>
					}
					{/* <Radio.Group
						onChange={this.onChange}
						value={this.state.addType}
						name="addType"
					>
						<Radio style={radioStyle} value="preset">
							<p>Preset Asset</p>
							<p>
								<Select
									name="currency"
									value={currency}
									onChange={this.handleSelect}
									style={{ display: 'block' }}
								>
									<Select.Option value="btc">
										Bitcoin (BTC)
									</Select.Option>
									<Select.Option value="eth">
										Ethereum (ETH)
									</Select.Option>
									<Select.Option value="xrp">
										Ripple (XRP)
									</Select.Option>
									<Select.Option value="xht">
										HollaEx (XHT)
									</Select.Option>
									<Select.Option value="bch">
										Bitcoin Cash (BCH)
									</Select.Option>
									<Select.Option value="usdt">
										Tether (USDT)
									</Select.Option>
								</Select>
							</p>
						</Radio>
						<Radio style={radioStyle} value="new">
							Create New Asset
						</Radio>
					</Radio.Group> */}
				</Modal>
			</FormWrapper>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		state: state.setup.biz,
		coins: state.coin,
		exchange: state.exchange[0],
		allCoins: state.coin
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators(SetupAction, dispatch),
	setCoin: bindActionCreators(CoinAction.setCoin, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Assets);
